export default __webpack_public_path__ + "static/media/popup.4623e1d7.jpg";